<template>
<div id="contents">

  <div id="works" class="page_contents">

    <div id="works_contents">
      <div id="works_vp_cm_show" v-if="vp_cm">

        <div id="works_vp_cm_show_main" class="page_main_contents">
          <h1>{{vp_cm.title}}<br />{{vp_cm.work_name}}</h1>

          <div id="works_vp_cm_show_movie">
            <video :src="vp_cm.movie_file" :poster="vp_cm.kv_image" ref="video"  controls></video>
          </div>

          <p class="page_close"><a href="#"><img src="../assets/img/common/page/close_icon.png" width="55" alt="閉じるボタン" ></a></p>
          <p class="page_close"><router-link v-bind:to="{name: 'vp_cm_index'}"><img src="../assets/img/common/page/close_icon.png" width="55" alt="閉じるボタン" ></router-link></p>
        </div><!-- #works_program_show_main -->

        <div class="contact_btn_wrap">
          <p class="contact_btn"><a href="https://movie.tv-asahipro.co.jp/" target="_blank" class="c_link">動画制作サービスへ</a></p>
        </div><!-- .contact_btn_wrap -->

        <ul id="page_nav">
          <p v-if="vp_cm.next_post_id"><router-link v-bind:to="{name: 'vp_cm_show', params: {id: vp_cm.next_post_id}}"><img src="../assets/img/common/page/arrow.png" width="20" alt="右矢印" ></router-link></p>
          <p v-else></p>

          <p v-if="vp_cm.prev_post_id"><router-link v-bind:to="{name: 'vp_cm_show', params: {id: vp_cm.prev_post_id}}"><img src="../assets/img/common/page/arrow.png" width="20" alt="左矢印" ></router-link></p>
          <p v-else></p>
        </ul><!-- #page_nav -->

      </div><!-- #works_vp_cm_show -->
    </div><!-- #works_contents -->
  </div><!-- #works -->



</div><!-- #contents -->
</template>

<script>
export default {
  name: 'vp_cm_show',
  data() {
    return {
      api_url: this.$parent.api_base_url+'/api/vp_cm/show.php',
      vp_cm: null,
      error: null
    }
  },
  methods: {
    fetch_vp_cm(){
      this.$axios
        .get(this.api_url ,{
          params: {
            id: this.$route.params.id
          }
        })
        .then(response => {
          console.log('response.data', response.data)
          this.vp_cm = response.data.item[0]
        })
        .catch(error => {
          console.log(error)
          this.error = true
        })
        .finally(() => {
          var video = this.$refs.video;
        	  video.addEventListener('ended', function() {
            video.load();
          }, false);
        })
    }
  },
  watch: {
    '$route' (to, from) {
      this.fetch_vp_cm()
    }
  },
  mounted () {
    this.fetch_vp_cm()
    this.$emit('page_fade')
    console.log(this.$refs)
  },
  updated (){
    this.$emit('page_fade')
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/vp_cm_show.vue